import React from "react";
import S from "./FormSuccess.styled";

type FormSuccessProps = {
  feedback?: boolean;
  bookLocation?: boolean;
};

const FormSuccess: React.FC<FormSuccessProps> = ({
  feedback,
  bookLocation,
}) => {
  return (
    <S.Container>
      {feedback ? (
        <>
          <S.H4>Tack för att du lämnat feedback!</S.H4>
          <S.Text>
            Det är mottaget. Gäller det förslag på verksamhet noterar kansliet
            dina önskemål. Gäller det synpunkt på något som ägt rum så kommer vi
            kontakta dig inom 3 arbetsdagar.
          </S.Text>
        </>
      ) : bookLocation ? (
        <>
          <S.H4>Tack för din bokning</S.H4>
          <S.Text>
            Vi återkommer till dig inom kort för att bekräfta bokningen.
          </S.Text>
        </>
      ) : (
        <>
          <S.H4>Tack för din ansökan</S.H4>
          <S.Text>Har du frågor så kontakta gärna oss.</S.Text>
        </>
      )}

      <S.ButtonWrapper>
        <S.BackButton onClick={() => window.location.reload()}>
          Tillbaka till formuläret
        </S.BackButton>
        <S.StartButton onClick={() => (window.location.href = "/")}>
          Till startsida
        </S.StartButton>
      </S.ButtonWrapper>
    </S.Container>
  );
};

export default FormSuccess;
